import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface CurrencyEditorViewProps {
	value?: number;
	onChange: (value: any) => void;
	mode: ControlMode;
	required?: boolean;
	label?: string;
	currencies: CurrencySummary[] | DropdownRequest<CurrencySummary>;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	currencyArrayObjectType: boolean;
}

export class CurrencyEditorView extends React.Component<CurrencyEditorViewProps, any> {
	constructor(props) {
		super(props);
	}

	render() {
		let query;
		let options;

		if (this.props.currencyArrayObjectType) {
			options = this.props.currencies;
		} else {
			query = this.props.currencies;
		}
		let label = this.props.label;
		if (label === undefined) {
			label = 'Currency';
		}

		return (
			<DropdownView
				label={label}
				required={this.props.required}
				model={this.props.value}
				onGetErrorMessage={this.props.onGetErrorMessage}
				disabled={this.props.mode == 'display'}
				onChanged={(item) => {
					this.props.onChange(item);
				}}
				request={query}
				options={options}
				keyField="id"
				textField="iso3Name"
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/currencies/parts/currency-editor.view.tsx